import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {GrowlComponent} from '@catmodules/widgets/growl/components/growl.component';
import {ClickOutsideDirective} from '@catmodules/widgets/growl/directives/click-outside.directive';
import {DomHandlerService} from '@catmodules/widgets/growl/services/dom-handler.service';
import {MessageService} from '@catmodules/widgets/growl/services/message.service';

const publicComponents = [
  GrowlComponent,
  ClickOutsideDirective,
];

@NgModule({
  imports: [CommonModule],
  exports: [
    ...publicComponents,
  ],
  declarations: [
    ...publicComponents,
  ],
  entryComponents: [],
  providers: [MessageService, DomHandlerService],
})
export class GrowlModule {

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/widgets/growl/growl.module.ts